import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_EXTERNAL_RESSOURCES';

export async function getExternalRessources(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getExternalRessources - Start');

        const getExternalRessources =
            await DashboardService.CodevService.getExternalRessources(userData, params);

        LoggerService.logInfo('Action - getExternalRessources - End - Success');

        return ResultModel.newSuccessResult(getExternalRessources);
    }
    catch (error) {
        LoggerService.logInfo('Action - getExternalRessources - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
